<template>
    <div class="card">
        <div class="title">
            <div class="name">
                {{title}}
            </div>
            <router-link class="more" v-bind:to="url" target="_blank">更多</router-link>
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name:"HomeCard",
    props:{
        title:String,
        url:String
    }
}
</script>

<style lang="scss" scoped>
.card{
    width: 380px;
    height: 400px;
    background-color: #fefefe;
    
    .title{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px silver solid;
        .name{
            height: 40px;
            width: 100px;
            text-align: center;
            line-height: 40px;
            color: white;
            background-color: #1DB5CD;
            
        }
        .more{
            margin-right: 20px;
            color: #bbb;
            line-height: 40px;
            font-size: 1.6ch;
            font-weight: 500;
        }
        a{
            text-decoration: none;
        }
    }
}
</style>